// extracted by mini-css-extract-plugin
module.exports = {"speakerBtn":"speakerBtn___3njIf","icon":"icon___3iHen","disable":"disable___3ZKdd"};